<template>
    <span>
        <router-link v-if="$root.hasPermission(['settings.manage.users', 'settings.view.users']) && user.UserId && !plainText" :to="`/users/view/${user.UserId}`" :title="title">
            {{ user.FirstName }} {{ user.LastName }} <span v-if="user.deleted_at">&nbsp;[Deleted]</span>
        </router-link>
        <span v-else :title="title">
            {{ user.FirstName }} {{ user.LastName }} <span v-if="user.deleted_at">&nbsp;[Deleted]</span>
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                required: false
            },

            plainText: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {

            }
        },

        computed: {
            title(){
                //Setup
                var title = 'View User';

                //Check for email
                if(this.user.email)
                {
                    title += ', Email: '+this.user.email;
                }

                //send it
                return title;
            },
        },

        methods: {


        },

        mounted() {

        }
    }
</script>
